import React, { Component } from 'react'
import './index.less'

/**
 * @param {boolean} show 是否显示(必传)
 * @Author: KK
 * @Date: 2022-12-09
 * @LastEditors: KK
 * @LastEditTime: 2022-12-09
 * @desc: 扭蛋机专属加载动画（放入想要的盒子即可触发）
 */

export default class LoadingGashapon extends Component {
  render() {
    let isShow = this.props.show || false
    return (
      isShow && (
        <div className="gashapon-loading-wrap">
          <img className='shakeEgg' src="/img/app/gashapon/egg.png" alt="" />
          <div className='load'>
            <div className="item"></div>
            <div className="item"></div>
            <div className="item"></div>
          </div>
        </div>
      )
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/gashapon/LoadingComp/index.js